import styled from 'styled-components';
import {
  breakpoints,
  colors,
  fonts,
  getTypography,
  pxToCssFont,
  pxToCssFontSize,
} from '@vfit/shared/themes';

export const BannerContainer = styled.div`
  display: flex;
  padding: 64px 80px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 0 0 20px 20px;
  position: relative;
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

export const OfferSection = styled.div`
  display: flex;
  width: 443px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const CardDetails = styled.div`
  display: flex;
  width: 515px;
  padding: 32px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 20px;
  background-color: ${colors.$ffffff};
  border: 1px solid ${colors.$bebebe};
`;

export const OfferDetails = styled.div<{ pdpLiteOfferNameCard: string | undefined }>`
  display: flex;
  padding: 0 36px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  position: relative;
  .productDescription {
    margin: 0;
    color: ${colors.$0d0d0d};
    p {
      margin: 0 !important;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .productDescription div {
      ${pxToCssFontSize(14)}
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    .productDescription div {
      ${pxToCssFontSize(14)}
    }
  }
  .image-atoms-top-right {
    position: absolute;
    top: ${(props) => (props.pdpLiteOfferNameCard ? '5px' : '13px')};
    right: 36px;
    z-index: 2;
    width: 40px;
  }
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const Title = styled.div`
  font-family: ${fonts.vodafone};
  ${pxToCssFont(36, 45)}
  color: ${colors.$ffffff};
  font-style: normal;
  font-weight: 800;
  max-width: 405px;
`;
export const offerNameCardTitle = styled.div`
  p {
    margin: 0;
  }
  ${getTypography('body1.bold')}
  ${pxToCssFont(18, 24)}
  padding-bottom: 8px;
`;
export const SubtitleCta = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(16, 22)}
  font-style: normal;
  font-weight: 700;
  align-self: stretch;
  color: ${colors.$ffffff};
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const TagContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const Tag = styled.div<{
  bgColor?: string;
  color?: string;
}>`
  ${({ bgColor }) => `background: ${bgColor || colors.$ffffff}`};
  ${({ color }) => `color: ${color || colors.$0d0d0d}`};
  border-radius: 20px;
  padding: 6px 12px;
  span {
    font-family: ${fonts.vodafone};
    font-weight: 700;
    ${pxToCssFont(12, 16)}
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
`;

export const DivImgContainer = styled.div`
  height: 100%;
  width: 100%;
  max-height: 100%;
  min-width: 100%;
  overflow: hidden;
  z-index: -1;
  object-fit: contain;
  object-position: center;
  border-radius: 0 0 20px 20px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ModalTitle = styled.div`
  div {
    margin: 0;
    margin-bottom: 24px;
  }
`;

export const ModalContent = styled.div`
  div {
    margin: 0;
  }
`;

export const GoBackLabel = styled.div`
  color: ${colors.$ffffff};
  font-family: ${fonts.vodafone};
  font-style: normal;
  font-weight: 400;
  ${pxToCssFont(16, 22)};
`;

